import {useRef, useEffect} from 'react';
import {select, pie, arc, interpolate} from 'd3';

import useResizeObserver from '../../Utils/resizeObserver';
import {tooltip} from './Component';

const Piechart = ({data, wrapperRef, dataKey, label}) => {
  const svgRef=useRef()
  const dimensions=useResizeObserver(wrapperRef)
  
  useEffect(() => {
    const svg=select(svgRef.current)
    if(!dimensions) return;
    const radius = Math.min(dimensions.width, dimensions.height) / 2;
    const arcGenerator=arc().innerRadius(radius/2).outerRadius(radius)
    .padAngle(0.08)
    const pieGenerator=pie()
    .value(d => d[dataKey]).sort(null);
    const instructions=pieGenerator(data)    

    svg.selectAll(".slice")
    .data(instructions)
    .join("path")
    .attr("class", "slice")
    .attr("fill", (value)=>value.data.fill)
    .style("transform", `translate(${dimensions.width/2}px, ${dimensions.height/2}px)`)
    .on('mouseover', (event, d) => {
      // Show tooltip on hover
      tooltip.transition().style('opacity', 1);
      tooltip
      .html(`${label}: ${d.data[label]}<br/>${dataKey}: ${d.data[dataKey]}`)
      .style('left', `${event.pageX}px`)
      .style('top', `${event.pageY - 28}px`);
    })
    .on('mouseout', () => {
        // Hide tooltip on mouseout
        tooltip.transition().duration(500).style('opacity', 0);
    })
    .transition()
    .attrTween("d", function(nextInstruction){
        const interpolator=interpolate(this.lastInstruction, nextInstruction)
        this.lastInstruction=interpolator(1)
        return function(t){
            return arcGenerator(interpolator(t))
        }
    })

  }, [dimensions, data, dataKey, label])
  return (
    <div className='chart_wrapper_container'>
      <svg ref={svgRef}>
      </svg>
    </div>
  )
}

export default Piechart